import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { config } from "@/config";
import { api } from "@/lib/api";

interface PartnerResponse {
	data: {
		partner_type?: string;
	};
}

export const Route = createFileRoute("/flex/$id")({
	component: FlexRedirect,
});

function FlexRedirect() {
	const { id: partnerUuid } = Route.useParams();
	const [error, setError] = useState(false);

	console.log("[FlexRedirect] Component mounted", {
		partnerUuid,
		currentUrl: window.location.href,
		referrer: document.referrer,
	});

	useEffect(() => {
		const redirect = async () => {
			let utmMedium = "sharing_link";
			let partnerExists = false;

			console.log("[FlexRedirect] Starting redirect flow", {
				partnerUuid,
				webServiceUrl: config.urls.webServiceUrl,
			});

			try {
				const response = await api.get<PartnerResponse>(
					`/api/v0/leads/partners/${partnerUuid}`,
					{ params: { methods: "partner_type" } },
				);

				console.log("[FlexRedirect] API response", {
					status: response.status,
					data: response.data,
					hasData: !!response.data?.data,
				});

				if (response.data?.data) {
					partnerExists = true;
					if (response.data.data.partner_type) {
						utmMedium = response.data.data.partner_type;
					}
				}
			} catch (err) {
				console.error("[FlexRedirect] API error", {
					error: err,
					message: err instanceof Error ? err.message : "Unknown error",
					partnerUuid,
				});
				setError(true);
				return;
			}

			if (!partnerExists) {
				console.warn("[FlexRedirect] Partner not found in response", {
					partnerUuid,
				});
				setError(true);
				return;
			}

			const queryString = new URLSearchParams({
				utm_source: partnerUuid,
				utm_medium: utmMedium,
				utm_campaign: "partner",
				partner_source: partnerUuid,
			}).toString();

			const baseUrl = config.urls.webServiceUrl.replace(/\/$/, "");
			const redirectUrl = `${baseUrl}?${queryString}`;

			console.log("[FlexRedirect] Redirecting to", {
				baseUrl,
				redirectUrl,
				utmMedium,
				partnerUuid,
			});

			window.location.href = redirectUrl;
		};

		redirect();
	}, [partnerUuid]);

	if (error) {
		return (
			<div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white">
				<div className="flex flex-col items-center gap-6 text-center px-4">
					<div className="text-8xl font-bold text-gray-200">404</div>
					<h1 className="text-2xl font-semibold text-gray-900">
						Partner Not Found
					</h1>
					<p className="text-gray-500 max-w-md">
						The partner link you're looking for doesn't exist or may have been
						removed.
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white">
			<div className="flex flex-col items-center gap-6">
				<Loader2 className="h-16 w-16 animate-spin text-[#3F83F8]" />
				<div className="text-center">
					<h1 className="text-xl font-semibold text-gray-900 mb-2">
						Redirecting you...
					</h1>
				</div>
			</div>
		</div>
	);
}
